import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	timeline: {
		id: 'spa-apps-advanced-roadmaps-plan.plan-report.timeline',
		defaultMessage: 'Timeline',
		description: 'Heading for plan timeline page',
	},
});
